function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState } from "vuex";
import tasks from '@/js/tasks';
import { ROLES_LIST, DATAPLEX_STATES } from '@/js/constants';
import DialogsComponent from "@/components/DialogsComponent.vue";
import bots_services from '@/apps/chatbots/services/bots_services';
import OrganizacionComponent from '@/components/OrganizacionComponent.vue';
import domainService from '@/apps/data-platform/services/master_data/domain_service';
export default {
  components: {
    DialogsComponent: DialogsComponent,
    OrganizacionComponent: OrganizacionComponent
  },
  data: function data() {
    return {
      DATAPLEX_STATES: DATAPLEX_STATES,
      tab: 0,
      edit: false,
      view: false,
      filters: {},
      show_detail: false,
      filter_enabled: true,
      collapse_filter: false,
      item_selected: {},
      data: [],
      data_to_filter: [],
      list_orgs: [],
      pagination: {
        total: 0,
        limit: 10,
        offset: 1,
        current: 1
      },
      type_params: [{
        value: 'HEADER',
        text: 'Cabecera'
      }, {
        value: 'URL_PARAM',
        text: 'URL Param'
      }],
      rules: {
        name: [function (v) {
          return !!v || 'El campo es requerido.';
        }, function (v) {
          return v && v.length <= 100 || 'Menor o igual a 100 caracteres.';
        }],
        otros: [function (v) {
          return !!v || 'El campo es requerido.';
        }, function (v) {
          return v && v.length <= 500 || 'Menor o igual a 500 caracteres.';
        }],
        url: [function (v) {
          return !!v || 'El campo es requerido.';
        }, function (v) {
          return v && v.length <= 1000 || 'Menor o igual a 1000 caracteres.';
        }],
        url_prd: [function (v) {
          return !!v || 'El campo es requerido.';
        }, function (v) {
          return v && v.length <= 1000 || 'Menor o igual a 1000 caracteres.';
        }],
        description: [function (v) {
          return v == "" || v == undefined || v == null || v && v.length <= 1024 || 'Menor o igual a 1024 caracteres.';
        }]
      }
    };
  },
  computed: _objectSpread(_objectSpread({}, mapState('data-platform', ['projects', 'catalogs', 'orgs', 'isDomainItc', 'has_dataplex_active'])), {}, {
    getClassTable: function getClassTable() {
      if (this.filter_enabled) {
        return 'col-md-9 col-sm-12';
      } else {
        return 'col-sm-12';
      }
    },
    headers: function headers() {
      return [{
        value: 'name',
        text: this.traductor('chatbots.bots.metadata.name')
      }, {
        value: 'description',
        text: this.traductor('chatbots.bots.metadata.description')
      }, {
        value: 'url',
        text: this.traductor('chatbots.bots.metadata.url')
      }, {
        value: 'domain',
        text: 'Domain'
      }, {
        value: 'actions',
        text: this.traductor('chatbots.bots.metadata.actions')
      }];
    }
  }),
  created: function created() {
    this.listBots();
    this.getListOrgsDetailed();
  },
  methods: {
    traductor: function traductor(key) {
      return this.$i18n.t(key);
    },
    getListOrgsDetailed: function getListOrgsDetailed() {
      var _this = this;
      domainService.getOrganizationsDetail().then(function (response) {
        if (response.success) {
          _this.list_orgs = response.data;
        }
      });
    },
    formatDate: function formatDate(data) {
      if (data) return data ? data.substring(0, 19).replace("T", " ") : '';
      return "";
    },
    onEnableFilter: function onEnableFilter() {
      this.filter_enabled = !this.filter_enabled;
    },
    onSearch: function onSearch() {
      var _this2 = this;
      this.data = Object.assign([], this.data_to_filter);
      if (this.filters.name) {
        this.data = this.data.filter(function (x) {
          return x.name.toUpperCase().indexOf(_this2.filters.name.toUpperCase()) != -1;
        });
      }
      if (this.filters.description) {
        this.data = this.data.filter(function (x) {
          return x.description.toUpperCase().indexOf(_this2.filters.description.toUpperCase()) != -1;
        });
      }
    },
    onLimpiar: function onLimpiar() {
      this.data = Object.assign([], this.data_to_filter);
      this.resetFilters();
    },
    resetFilters: function resetFilters() {
      this.filters = {};
      this.listBots();
    },
    listBots: function listBots() {
      var _this3 = this;
      bots_services.getAll().then(function (response) {
        console.log(response);
        if (response.success) {
          _this3.data = response.data;
          _this3.data_to_filter = Object.assign([], _this3.data);
          _this3.pagination.total = response.data.length;
        }
      });
    },
    onSaveBot: function onSaveBot() {
      var _this4 = this;
      bots_services.create(this.item_selected).then(function (response) {
        if (response.success) {
          tasks.toast.success("El registro se guardó correctamente.");
          _this4.$refs["DIALOG_CRUD_BOT"].onClose();
          _this4.resetFilters();
        } else {
          tasks.toast.warning("No se pudo guardar el registro.");
        }
      });
    },
    onUpdateBot: function onUpdateBot() {
      var _this5 = this;
      bots_services.update(this.item_selected.id, this.item_selected).then(function (response) {
        if (response.success) {
          tasks.toast.success("El registro se guardó correctamente.");
          _this5.$refs["DIALOG_CRUD_BOT"].onClose();
          _this5.resetFilters();
        } else {
          tasks.toast.warning("No se pudo guardar el registro.");
        }
      });
    },
    goCreatePage: function goCreatePage() {
      this.edit = false;
      this.view = false;
      this.item_selected = {};
      this.$refs["DIALOG_CRUD_BOT"].onOpen();
    },
    onEditProject: function onEditProject(item) {
      this.edit = true;
      this.view = false;
      this.item_selected = Object.assign({}, item);
      this.$refs["DIALOG_CRUD_BOT"].onOpen();
    },
    onViewProject: function onViewProject(item) {
      this.edit = false;
      this.view = true;
      this.item_selected = Object.assign({}, item);
      this.$refs["DIALOG_CRUD_BOT"].onOpen();
    },
    onRemoveProject: function onRemoveProject(item) {
      this.item_selected = Object.assign({}, item);
      this.$refs["DIALOG_REMOVE_BOT"].onOpen();
    },
    onConfirmRemoveProject: function onConfirmRemoveProject(value) {
      var _this6 = this;
      if (value) {
        bots_services.delete(this.item_selected.id).then(function (response) {
          if (response.success) {
            tasks.toast.success("Se ha eliminado correctamente el registro.");
            _this6.onLimpiar();
            _this6.$refs["DIALOG_REMOVE_BOT"].onClose();
          } else {
            tasks.toast.error("No se ha podido eliminar el registro.");
          }
        });
      } else {
        this.$refs["DIALOG_REMOVE_BOT"].onClose();
      }
    }
  }
};